/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search_page_title_content22 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("en", i.count, {});
	if (countPlural == "one") return `Search among ${i.count} resources`;
	if (countPlural == "many") return `Search among more than ${i.count} resources`;
	if (countPlural == "other") return `Search among more than ${i.count} resources`;
	if (countPlural == "zero") return `No resources available to search`;
	return "SEARCH_PAGE_TITLE_CONTENT";
};

const fr_search_page_title_content22 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("fr", i.count, {});
	if (countPlural == "one") return `Rechercher dans la ressource`;
	if (countPlural == "many") return `Rechercher parmi plus de ${i.count} ressources`;
	if (countPlural == "other") return `Rechercher parmi plus de ${i.count} ressources`;
	if (countPlural == "zero") return `Aucune ressources disponible pour la recherche`;
	return "SEARCH_PAGE_TITLE_CONTENT";
};

const de_search_page_title_content22 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("de", i.count, {});
	if (countPlural == "one") return `Durchsuchen Sie über ${i.count} Ressource`;
	if (countPlural == "many") return `Durchsuchen Sie über ${i.count} Ressourcen`;
	if (countPlural == "other") return `Durchsuchen Sie über ${i.count} Ressourcen`;
	if (countPlural == "zero") return `Keine Ressourcen zum Durchsuchen verfügbar`;
	return "SEARCH_PAGE_TITLE_CONTENT";
};

const es_search_page_title_content22 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("es", i.count, {});
	if (countPlural == "one") return `Buscar en más de ${i.count} recurso`;
	if (countPlural == "many") return `Buscar en más de ${i.count} recursos`;
	if (countPlural == "other") return `Buscar en más de ${i.count} recursos`;
	if (countPlural == "zero") return `No hay recursos disponibles para buscar`;
	return "SEARCH_PAGE_TITLE_CONTENT";
};

const it_search_page_title_content22 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("it", i.count, {});
	if (countPlural == "one") return `Cerca tra ${i.count} risorse`;
	if (countPlural == "many") return `Cerca tra ${i.count} risorse`;
	if (countPlural == "other") return `Cerca tra più di ${i.count} risorse`;
	if (countPlural == "zero") return `Nessuna raccolta disponibile per la ricerca`;
	return "SEARCH_PAGE_TITLE_CONTENT";
};

const ar_search_page_title_content22 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("ar", i.count, {});
	if (countPlural == "one") return `ابحث بين ${i.count} الموارد`;
	if (countPlural == "many") return `ابحث بين ${i.count} الموارد`;
	if (countPlural == "other") return `ابحث بين أكثر من ${i.count} من الموارد`;
	if (countPlural == "zero") return `لا توجد مجموعات متاحة للبحث`;
	return "SEARCH_PAGE_TITLE_CONTENT";
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_page_title_content22 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_page_title_content22(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_page_title_content22", locale)
	if (locale === "en") return en_search_page_title_content22(inputs)
	if (locale === "fr") return fr_search_page_title_content22(inputs)
	if (locale === "de") return de_search_page_title_content22(inputs)
	if (locale === "es") return es_search_page_title_content22(inputs)
	if (locale === "it") return it_search_page_title_content22(inputs)
	return ar_search_page_title_content22(inputs)
};
export { search_page_title_content22 as "SEARCH_PAGE_TITLE_CONTENT" }